import MuiIconButton from '@mui/material/IconButton';
import { alpha, styled } from '@mui/material/styles';
import type { IconButtonVariant, IconButtonVisualSize } from './IconButton.props';

interface StyledIconButtonProps {
  iconButtonVariant: IconButtonVariant;
  visualSize: IconButtonVisualSize;
}

const shouldForwardProp = (prop: PropertyKey) => prop !== 'iconButtonVariant' && prop !== 'visualSize';

export const StyledIconButton = styled(MuiIconButton, {
  shouldForwardProp,
})<StyledIconButtonProps>(({ iconButtonVariant, theme, visualSize }) => ({
  ...(visualSize === 'compact' ? {
    height: 'var(--icon-button-compact-size, 20px)',
    padding: 0,
    width: 'var(--icon-button-compact-size, 20px)',
    '& svg': {
      display: 'block',
      fontSize: 'var(--icon-button-compact-icon-size, 16px)',
      height: 'var(--icon-button-compact-icon-size, 16px)',
      width: 'var(--icon-button-compact-icon-size, 16px)',
    },
  } : {}),
  ...(iconButtonVariant === 'ghost' ? {
    borderRadius: 'var(--icon-button-radius, 4px)',
    color: theme.palette.neutral[500],
    transition: theme.transitions.create(['background-color', 'color', 'opacity'], {
      duration: theme.transitions.duration.shortest,
    }),
    '&:hover, &:focus-visible, &[aria-pressed="true"]': {
      backgroundColor: theme.palette.neutral[200],
      color: theme.palette.neutral[700],
    },
    '&.Mui-disabled': {
      color: alpha(theme.palette.neutral[500], 0.45),
      opacity: 0.6,
    },
  } : {}),
  '&:focus-visible': {
    outline: `3px solid ${alpha(theme.palette.primary.main, 0.28)}`,
    outlineOffset: 2,
  },
}));
